import axios from "axios";
import history from "../utils/history";

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_HOST_API,
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("tokenData");
      api.defaults.headers.Authorization = undefined;
      history.push("/");
    } else {
      throw error;
    }
  }
);

export default api;
